<template>
    <div class="sidenav-header">
      <ul class="navbar-nav justify-content-end">
          <li class="d-flex align-items-center">
            <router-link class="navbar-brand" to="/">
              <img src="@/assets/img/logo.svg" class="navbar-brand-img mx-auto" />
            </router-link>
            <a
              v-if="showCloseIcon"
              id="iconNavbarSidenav"
              href="#"
              class="p-0 nav-link text-body"
              @click="toggleSidebar"
            >
              <div class="sidenav-toggler-inner" style="width: 10px;">
                <img src="@/assets/img/x-solid.svg" />
              </div>
            </a>
            
          </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: 'SidenavHeader',
  computed: {
    ...mapState(["isPinned"]),
    showCloseIcon() {
      return !this.isPinned;
    }
  },
};
</script>